module.exports = __webpack_public_path__ + "static/media/p7.3cafe22c.webp";